import { useSearchParams } from 'react-router-dom';

import { isNotEmptyString } from '../../../shared/validators/common';
import PageContentContainer from '../../common/components/page-content-container/PageContentContainer';

import { ActionUrlList } from './components/ActionUrlList';
import { CreateActionUrlFrom } from './components/CreateActionUrlFrom';

import cardStyles from '../../../theme/styles/Card.module.css';
import { EditActionUrlFrom } from './components/EditActionUrlFrom';

export const ActionUrl = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  return (
    <PageContentContainer
      listSectionContent={<ActionUrlList selectedItemId={id} />}
      formSectionContent={(
        <div className={cardStyles.card}>
          <div className={cardStyles.card_content}>
            {isNotEmptyString(id) ? <EditActionUrlFrom id={id!} /> : <CreateActionUrlFrom />}
          </div>
        </div>
      )}
    />
  )
}
